/* Shopify's locale-aware Ajax rate API. No cart mutation, no third-party
 * address transfer, no guessed prices, and no order/email submission. */
if (!customElements.get('ots-shipping-estimator')) {
  customElements.define('ots-shipping-estimator', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-rate-status]');
      this.results = this.querySelector('[data-rate-results]');
      this.submit = this.calculate.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
    disconnectedCallback() { this.form?.removeEventListener('submit', this.submit); this.controller?.abort(); }
    async calculate(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      this.controller?.abort();
      const controller = new AbortController(); this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 25000);
      const button = this.form.querySelector('button');
      button.disabled = true; this.results.replaceChildren();
      this.status.textContent = 'Checking available rates…';
      const cartUrl = this.dataset.cartUrl || '/cart';
      const request = async (url, options = {}) => {
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: {Accept: 'application/json'}, ...options });
        if (!response.ok) throw new Error('Rates unavailable for this address. Check the state and ZIP, or contact us for a quote.');
        return response.json();
      };
      try {
        const cart = await request(`${cartUrl}.js`);
        if (!cart.items?.length || (this.dataset.productId && !cart.items.some(item => String(item.product_id) === this.dataset.productId))) {
          this.status.textContent = this.dataset.productId ? 'Add this item using the Add to cart button first, then calculate. Your cart has not been changed.' : 'Your cart is empty. Add an item first to calculate shipping.';
          return;
        }
        const fingerprint = JSON.stringify(cart.items.map(item => [item.key,item.quantity]));
        const values = new FormData(this.form);
        const query = new URLSearchParams({'shipping_address[country]':'United States','shipping_address[province]':String(values.get('province')),'shipping_address[zip]':String(values.get('zip')).trim()});
        await request(`${cartUrl}/prepare_shipping_rates.json?${query}`, {method:'POST'});
        let rates;
        for (let attempt=0; attempt<10; attempt++) {
          const response = await request(`${cartUrl}/async_shipping_rates.json?${query}`);
          if (response && Array.isArray(response.shipping_rates)) { rates = response.shipping_rates; break; }
          await new Promise(resolve => setTimeout(resolve,1000));
          if (controller.signal.aborted) throw new DOMException('Aborted','AbortError');
        }
        const latest = await request(`${cartUrl}.js`);
        if (fingerprint !== JSON.stringify(latest.items.map(item => [item.key,item.quantity]))) throw new Error('Your cart changed while calculating. Please calculate again.');
        if (!rates) throw new Error('The carrier is taking longer than expected. Try again or check rates at checkout.');
        if (!rates.length) throw new Error('No online shipping rate is available for this cart and destination. Please contact us for a quote.');
        for (const rate of rates) {
          const value = Number(rate.price);
          if (!Number.isFinite(value)) continue;
          const li = document.createElement('li');
          li.textContent = `${rate.name}: ${new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.dataset.currency || 'USD'}).format(value)}`;
          this.results.append(li);
        }
        this.status.textContent = `Estimated shipping for your entire cart (${cart.item_count} item${cart.item_count === 1 ? '' : 's'}). Taxes are not included. Recalculate after cart or address changes.`;
      } catch (error) {
        if (this.isConnected) this.status.textContent = error.name === 'AbortError' ? 'The estimate timed out. Please try again or check rates at checkout.' : error.message;
      } finally { clearTimeout(timeout); if(this.isConnected) button.disabled=false; }
    }
  });
}
